import {AppContextType, ListFilters, useAppContext} from 'common/context/AppContext'
import {useLocation, useNavigate} from 'react-router-dom'

const defaultFilters: ListFilters = {
    page: 0,
    pageSize: 10,
    sort: {
        name: 'modified',
        direction: 'desc'
    }
}

function getKey() {
    const location = useLocation()
    return location.pathname.split('/').slice(0, 3).join('/')
}

export function initListFilters(initialFilters?: Partial<ListFilters>) {
    const appContext = useAppContext()
    const navigateTo = useNavigate()

    const key = getKey()
    const filters = getFilters(appContext, key, {...defaultFilters, ...initialFilters})

    if (location.search && location.search.length > 1) {
        const params = location.search.substring(1).split('&')
        let filterSet = false
        if (params && params.length > 0) {
            params.forEach(param => {
                const parts = param.split('=')
                if (parts.length == 2) {
                    const name = parts[0]
                    const value = decodeURIComponent(parts[1])
                    if (name.endsWith("Id")) {
                        filters[name] = parseInt(value)
                    } else {
                        filters[name] = value
                    }
                    filterSet = true
                }
            })
        }
        if (filterSet) {
            // clean all query string parameters to avoid issues with filters
            navigateTo(window.location.pathname)
        }
    }
    return filters
}

function getFilters(appContext: AppContextType, key: string, defaultFilters?: ListFilters) {
    let filters = appContext.listFilters?.get(key)
    if (!filters) {
        filters = defaultFilters ? defaultFilters : {} as ListFilters
        const listFilters = appContext.listFilters || new Map<string, ListFilters>()
        listFilters.set(key, filters);
        appContext.setListFilters(listFilters)
    }
    return filters
}


export function useListFilters(setFilters: (filters: ListFilters) => void, initialFilters?: Partial<ListFilters>) {
    const appContext = useAppContext()
    const key = getKey()


    function clearFilters(filterNames?: Array<string>): void {
        const filters = getFilters(appContext, key)
        if (filterNames) {
            filterNames.forEach((filterName) => filters[filterName] = undefined)
        } else {
            Object.keys(filters).forEach((name) => filters[name] = undefined)
            Object.keys(defaultFilters).forEach((name) => filters[name] = defaultFilters[name])
            initialFilters && Object.keys(initialFilters).forEach((name) => filters[name] = initialFilters[name])
        }
        setFilters({...filters})
    }

    function setFilter<T extends keyof ListFilters>(filter: T, value: ListFilters[T]) {
        const filters = getFilters(appContext, key)
        filters[filter] = value
        setFilters({...filters})
    }

    function setFilter2<T extends keyof ListFilters>(filter: T, value: ListFilters[T], filter2: T, value2: ListFilters[T]) {
        const filters = getFilters(appContext, key)
        filters[filter] = value
        filters[filter2] = value2
        setFilters({...filters})
    }

    return {setFilter, setFilter2, clearFilters}
}
